import { render, staticRenderFns } from "./FaceList.vue?vue&type=template&id=53a657c9&scoped=true&"
import script from "./FaceList.vue?vue&type=script&lang=js&"
export * from "./FaceList.vue?vue&type=script&lang=js&"
import style0 from "./FaceList.vue?vue&type=style&index=0&id=53a657c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a657c9",
  null
  
)

export default component.exports